import React from 'react';
import ModalWrapper from 'Common/Components/ModalWrapper';
import {
  ModalTitle, Title, BodyText, ModalContent, ButtonsContainer,
  ConfirmButton, CancelButton, Warning, ModalBody
} from './styled';
import useKeyPress from 'Hooks/useKeyPress';

const pluralize = (word) => (/[^aeiou]y$/i.test(word) ? `${word.slice(0, -1)}ies` : `${word}s`);

const ModalConfirmation = ({
  handleSubmit, handleClose, entity, count, message, loading, wrapperTestId, confirmButtonTestId, cancelButtonTestId
}) => {
  const upperCaseTitle = entity.charAt(0).toUpperCase() + entity.slice(1);
  const pluralTitle = pluralize(upperCaseTitle);
  const countTitle = count === 1 ? upperCaseTitle : pluralTitle;
  const modalText = message || `You’re deleting ${count} ${countTitle}. This action cannot be undone. Are you sure you want to proceed?`;
  useKeyPress(() => {
    handleSubmit();
  }, ['Enter']);

  useKeyPress(() => {
    handleClose();
  }, ['Escape']);

  useKeyPress(() => {
    if (handleSubmit) handleSubmit();
  }, ['Enter']);

  useKeyPress(() => {
    if (handleClose) handleClose();
  }, ['Escape']);

  return (
    <ModalWrapper>
      <ModalContent data-testid={ wrapperTestId }>
        <ModalTitle>
          <Warning />
          <Title>{`Delete ${countTitle}`}</Title>
        </ModalTitle>
        <ModalBody>
          <BodyText>{modalText}</BodyText>
        </ModalBody>
        <ButtonsContainer>
          <CancelButton onClick={ handleClose } data-testid={ cancelButtonTestId }>
            Cancel
          </CancelButton>
          <ConfirmButton onClick={ handleSubmit } disabled={ loading } data-testid={ confirmButtonTestId }>
            Delete
          </ConfirmButton>
        </ButtonsContainer>
      </ModalContent>
    </ModalWrapper>
  );
};

export default ModalConfirmation;
